export default __webpack_public_path__ + "static/media/checklist.a212563c.svg";